import { Maximize2, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HealthPanel } from "../components/HealthPanel";
import { fmtDateTime } from "../lib/format";

export default function TvMode() {
  const [tick, setTick] = useState(0);
  const [at, setAt] = useState<string>(new Date().toISOString());
  useEffect(() => { const id = setInterval(() => setTick((t) => t + 1), 60000); return () => clearInterval(id); }, []);
  const full = () => { const el = document.documentElement; if (!document.fullscreenElement) el.requestFullscreen?.(); else document.exitFullscreen?.(); };
  return (
    <div className="min-h-screen bg-background text-foreground p-6 sm:p-10" data-testid="tv-page">
      <div className="mx-auto max-w-7xl space-y-6">
        <div className="flex items-center justify-between">
          <div><p className="text-xs font-bold uppercase tracking-[0.25em] text-muted-foreground">Yutaka Edu-Finance · Mode Rapat</p><p className="text-sm text-muted-foreground">Pembaruan otomatis tiap 60 detik · terakhir {fmtDateTime(at)}</p></div>
          <div className="flex gap-2">
            <button type="button" data-testid="tv-fullscreen" onClick={full} className="inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold hover:bg-muted"><Maximize2 className="h-3.5 w-3.5" /> Layar penuh</button>
            <Link to="/" data-testid="tv-exit" className="inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold hover:bg-muted"><X className="h-3.5 w-3.5" /> Keluar</Link>
          </div>
        </div>
        <HealthPanel key={tick} onLoaded={() => setAt(new Date().toISOString())} />
      </div>
    </div>
  );
}
